import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Shield, CheckCircle } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white">
      {/* Selo Verificado */}
      <div className="bg-green-600 py-4">
        <div className="elite-container">
          <div className="flex items-center justify-center space-x-3">
            <Shield className="h-6 w-6" />
            <span className="font-semibold text-lg">Canal Oficial Verificado</span>
            <CheckCircle className="h-6 w-6" />
          </div>
          <p className="text-center text-sm mt-2 opacity-90">
            Proteja-se contra fraudes. Só realize pagamentos através dos protocolos oficiais da União Lar & Vida.
          </p>
        </div>
      </div>

      <div className="elite-container py-16">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-4 mb-8">
              <img 
                src="./images/LOGO WHITE.png" 
                alt="UNIÃO LAR & VIDA" 
                className="h-16 w-16 object-contain"
              />
              <div>
                <h3 className="font-luxury text-2xl font-bold text-accent">UNIÃO LAR & VIDA</h3>
                <p className="text-slate-300 text-sm">Family-Owned Consultancy</p>
              </div>
            </div>
            <p className="text-slate-300 leading-relaxed mb-8 max-w-md">
              A consultoria multidisciplinar de elite especializada em realocação segura 
              e investimento imobiliário no Brasil para investidores africanos de alta renda.
            </p>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-accent mt-1 flex-shrink-0" />
                <div>
                  <p className="font-semibold text-white">Endereço Oficial</p>
                  <p className="text-slate-300 text-sm">
                    SHIN CA 1, Bloco A, Lote A, s/n<br />
                    Lago Norte, Brasília - DF, 71503-501<br />
                    Sala 453
                  </p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="h-5 w-5 text-accent" />
                <div>
                  <p className="font-semibold text-white">Telefone Oficial</p>
                  <p className="text-slate-300">+55 61 981568214</p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="h-5 w-5 text-accent" />
                <div>
                  <p className="font-semibold text-white">E-mail Corporativo</p>
                  <p className="text-slate-300">contato@uniaolarevida.com.br</p>
                </div>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-display text-lg font-semibold text-white mb-6">Navegação</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-slate-300 hover:text-accent transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-slate-300 hover:text-accent transition-colors">
                  About
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-slate-300 hover:text-accent transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/brazil" className="text-slate-300 hover:text-accent transition-colors">
                  Why Brazil
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-slate-300 hover:text-accent transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-display text-lg font-semibold text-white mb-6">Expertise</h4>
            <ul className="space-y-3 text-slate-300">
              <li>Legal Matrix</li>
              <li>Financial Matrix</li>
              <li>Technical Matrix</li>
              <li>Immigration Matrix</li>
              <li>Asset Protection</li>
              <li>Family Reunification</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-700 mt-12 pt-8">
          <div className="flex flex-col lg:flex-row justify-between items-center space-y-4 lg:space-y-0">
            <div className="text-slate-400 text-sm">
              <p>© 2026 União Lar & Vida Consultoria Ltda. Todos os direitos reservados.</p>
              <p className="mt-1">CNPJ: XX.XXX.XXX/0001-XX | Registro profissional em conformidade com a legislação brasileira.</p>
            </div>
            <div className="flex items-center space-x-2 text-sm text-slate-400">
              <Shield className="h-4 w-4 text-green-500" />
              <span>Empresa Familiar Verificada</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;